const computeTimeDifference = (start, end) => {
    return end.getTime() - start.getTime();
};

const computeBreakDurations = (wd) => {
    if (!wd.start || !wd.end || wd.workEntries.length === 0) {
        return { breakDurations: [], leadingBreakDuration: null, trailingBreakDuration: null, sumBreakDurations: 0 };
    }
    const start = new Date(wd.start);
    const end = new Date(wd.end);
    const entries = wd.workEntries;
    let breakDurations = [];

    for (let i = 0; i < entries.length - 1; i++) {
        let t1 = new Date(entries[i].end); // start of break
        let t2 = new Date(entries[i + 1].start); // end of break
        let diff = computeTimeDifference(t1, t2);
        breakDurations.push(diff);
    };

    let sumBreakDurations = 0;
    breakDurations.forEach((el) => sumBreakDurations += el);

    let leadingBreakDuration = null;
    if (start.getTime() !== new Date(entries[0].start).getTime()) {
        let d2 = new Date(entries[0].start);
        leadingBreakDuration = computeTimeDifference(start, d2);
        sumBreakDurations += leadingBreakDuration;
    }

    let trailingBreakDuration = null;
    if (wd.end !== entries[entries.length - 1].end) {
        let d1 = new Date(entries[entries.length - 1].end);
        trailingBreakDuration = computeTimeDifference(d1, end);
        sumBreakDurations += trailingBreakDuration;
    }

    return { breakDurations, leadingBreakDuration, trailingBreakDuration, sumBreakDurations };
};

const computeWorkDurations = (entries) => {
    let workDurations = [];

    for (let i = 0; i <= entries.length - 1; i++) {
        let t1 = new Date(entries[i].start); // start of break
        let t2 = new Date(entries[i].end); // end of break
        let diff = computeTimeDifference(t1, t2);
        workDurations.push(diff);
    };

    let sumWorkDurations = 0;
    workDurations.forEach((el) => sumWorkDurations += el);

    return { workDurations, sumWorkDurations };
};

const computeTimesFromWorkDay = (wd) => {
    const day = new Date(wd.date);
    const start = new Date(wd.start);
    const end = new Date(wd.end);

    return {
        day,
        start,
        end,
        ...computeWorkDurations(wd.workEntries),
        ...computeBreakDurations(wd),
    };
};

const computeDurations = (entries) => {
    let durations = entries.map(e => computeTimeDifference(e.start, e.end));
    let sum = durations.reduce((acc, c) => acc + c, 0);

    return { durations, sum };
}
const computeContractWorkTime = (contractInfo) =>
    contractInfo.mondayWorkLoad +
    contractInfo.tuesdayWorkLoad +
    contractInfo.wednesdayWorkLoad +
    contractInfo.thursdayWorkLoad +
    contractInfo.fridayWorkLoad +
    contractInfo.saturdayWorkLoad +
    contractInfo.sundayWorkLoad;

const computeDateDifferenceInDays = (dateInitial, dateFinal) =>
    (dateFinal - dateInitial) / 86_400_000;


export default {
    computeTimeDifference,
    computeBreakDurations,
    computeWorkDurations,
    computeTimesFromWorkDay,
    computeDateDifferenceInDays,
    computeContractWorkTime,
    computeDurations
}